import {ScanRepository} from '../repositories/ScanRepository';
import {AssignmentDetail} from '../entities/AssignmentDetail';

export class GetAssignmentByIdUseCase {
  constructor(private readonly scanRepository: ScanRepository) {}

  async execute(assignmentId: number): Promise<AssignmentDetail> {
    return await this.scanRepository.getAssignmentById(assignmentId);
  }
}
